import { render, staticRenderFns } from "./PhysiologicalParameterTab.vue?vue&type=template&id=34351951&scoped=true&"
import script from "./PhysiologicalParameterTab.vue?vue&type=script&lang=js&"
export * from "./PhysiologicalParameterTab.vue?vue&type=script&lang=js&"
import style0 from "./PhysiologicalParameterTab.vue?vue&type=style&index=0&id=34351951&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34351951",
  null
  
)

export default component.exports